namespace SP.Data {
    export class Item {
        //private static itemInfo: { [lotId: string]: ItemInfo } = {};

        static async getProductionInfos(first: number) {
            var response = await SP.get<any>("/api/v1/info/productionInfos/?first=" + first);
            if (response.status == 200) return response.data as ProductionInfo[];
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }

        static async getProductionInfo(ItemId: string) {
            var response = await SP.get<any>("/api/v1/info/productionInfo/" + ItemId);
            if (response.status == 200) return response.data as ProductionInfo;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }

        static async getItemInfo(itemId: string, useCache = true) {
            //if (useCache && this.itemInfo[itemId] != null) return this.itemInfo[itemId];
            var response = await SP.get<any>("/api/v1/item/get/" + itemId);
            if (response.status == 200) return response.data; // this.itemInfo[itemId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            //return this.itemInfo[itemId];
        }

        static async getWarehouseItemInfo(itemId: string, useCache = true) {
            //if (useCache && this.itemInfo[itemId] != null) return this.itemInfo[itemId];
            var response = await SP.get<any>("/api/v1/item/get/" + itemId + "?warehouseDetails=true");
            if (response.status == 200) return response.data; // this.itemInfo[itemId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            //return this.itemInfo[itemId];
        }

        static async searchItemInfos(keyword: string, customerId: string, resultCount: number, types: ItemType[] = null) {
            var kw = encodeURIComponent(keyword);
            var url = `/api/v1/item/list?deleted=false&maxResults=${resultCount}&reverseLookup=true&warehouseDetails=true&barcode=${kw}&keyword=${kw}`;

            if (types != null) {
                url += `&itemTypes=${types.join(",")}`;
            }

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache',
                    'api-customer': `${customerId}`
                }
            });

            const result = await response.json();
            if (result.status = !200) await SP.alertX(result.msg);

            return result.data as ItemInfo[];
        }

        static async getItemInfos(skus: string[], customerId: string) {
            const response = await fetch(`/api/v1/item/list?maxResults=10000000&warehouseDetails=true&skus=${skus.join(",")}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache',
                    'api-customer': `${customerId}`
                }
            });

            const result = await response.json();
            if (result.status = !200) await SP.alertX(result.msg);

            return result.data as ItemInfo[];
        }
    }
}